module.exports = __webpack_public_path__ + "img/5_45.97ca1ec6.png";